import Controller from "csi/action/Controller";
import New from "csi/table/New";
import xml from "csi/xml";
import declare from "dojo/_base/declare";
import ProductHierarchyFoodNewCopyParams from "./ProductHierarchyFoodNewCopyParams";
import ProductSelectProductHierarchyForm from "./ProductSelectProductHierarchyForm";

const NewFormulatedProductAddProductHierarchy = declare([New, ProductHierarchyFoodNewCopyParams], {
	/**
	 * @override
	 * Build Food and FormulatedMaterial request
	 */
	toWriterRequest() {
		if (this?.m_typeNode === "FormulatedMaterial") {
			const call = Controller.prototype.toWriterRequest.call(this);

			const fd = this.m_formData;
			const form = fd.m_source?.popupView as typeof ProductSelectProductHierarchyForm.prototype;
			const leafFolderLabel = form._labelLeafFolder;
			const leafFolderUrl = leafFolderLabel ? fd.getFieldValue(leafFolderLabel, true) : this.getCache().getNode(this.m_urlParent).__Parent__;
			const subRecipeName = fd.getFieldValue("RecipeDataSheet/Node Name", true);
			const subRecipeSubtype = fd.getFieldValue("RecipeDataSheet/Subtype", true);

			call.addParameter("ProductHierarchyFolder", xml.ATTR_REF, leafFolderUrl);

			if (subRecipeName) {
				call.addParameter("Recipe Name", xml.ATTR_STRING, subRecipeName);
			}
			if (subRecipeSubtype) {
				call.addParameter("Recipe Subtype", xml.ATTR_REF, subRecipeSubtype);
			}

			return call;
		} else {
			return this.inherited(arguments);
		}
	},

});

export = NewFormulatedProductAddProductHierarchy;